import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { addToWaitlist, fetchUserCount, addToUserCount } from 'src/waitlist/actions';
import Waitlist from 'src/views/components/waitlist/waitlist.jsx';

function mapStateToProps(state) {
  return {
    waitlistSuccess: state.waitlist.waitlistSuccess,
    email: state.waitlist.email,
    waitlistCount: state.waitlist.waitlistCount
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onAddToWaitlist: (email, type) => dispatch(addToWaitlist(email, type)),
    fetchUserCount:() => dispatch(fetchUserCount()),
    addToUserCount:() => dispatch(addToUserCount())
  };
}

const WaitlistContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(Waitlist));

export default WaitlistContainer;



// WEBPACK FOOTER //
// ./src/views/pages/waitlist/waitlist-page.js